import { callFunctionRaw } from "@/lib/callFunction.js";

// The public reset screen consumes this server-owned token format.
export async function requestAccountPasswordReset(email) {
  if (String(import.meta.env.VITE_OPTION_B_AUTH_HANDOFF_HOLD || "").toLowerCase() === "true") {
    throw new Error("Account recovery is temporarily unavailable.");
  }
  await callFunctionRaw(
    "account-password-reset",
    { action: "request", email, resetBasePath: "/reset-password" },
    { timeoutMs: 20000, skipAuth: true },
  );
}
